import { fromUnixToFullVisitdateStr, getHourFromUnix } from "../../utils/unix-timestamp";

import BookingLocation from "../Icons/BookingLocation";
import BookingStethIcon from "../Icons/BookingStethIcon";
import CalendarBookingIcon from "../Icons/CalendarBookingIcon";
import { LIST_GENDERS } from "../../config/params";
import PetsIcon from "../Icons/PetsIcon";
import React from "react";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { useUserDetail } from "../../services/user-detail/user-detail.service";

interface Position {
  lat: number;
  lng: number;
}

interface Location {
  idLocation: string;
  locationName: string;
  address: string;
  city: string;
  position: Position;
  email: string;
  phoneNumber: string;
  timeZone: string;
}

interface BookingDetails {
  appointmentType: string;
  start_at: number;
  end_at: number;
  location: Location;
  reasonsForVisit: string[];
  hospitalContact: string;
  appointment: any;
  initiation: "createBooking"| "bookingDetails";
}

// eslint-disable-next-line camelcase
const BookingDetails = ({ appointmentType, start_at, location, reasonsForVisit,
  appointment, initiation }: BookingDetails) => {
  const { user } = useUserDetail();
  const { selectedVisit } = useAppointmentStore();

  function getGender(species: string) {
    const gender = LIST_GENDERS.find((gender) => gender.value === species);

    return gender ? gender.label : species === "2" ? "Male" : species === "4" ? "Female" : undefined;
  }


  return (
    <div className="flex flex-col h-fit justify-center items-center gap-[2.5rem] w-full">
      <div className="flex flex-col gap-5 w-[90%] pt-1">
        <div className="flex w-full flex-col justify-around gap-4 bg-white px-5 py-3 h-full border border-gray-3
        rounded-xl">
          <div className="flex gap-5">
            <div className="flex flex-col justify-center items-center">
              <BookingLocation />
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-sm font-semibold">GoodVets {location.locationName}</span>
              <span className="text-gray-1 text-sm">{location.address}</span>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex flex-col justify-center items-center">
              <CalendarBookingIcon />
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex gap-1">
                <span className="text-sm font-semibold">
                  {fromUnixToFullVisitdateStr(start_at, location.timeZone).split(",")[0]}</span>
                <span className="border-r-2 border-gray-3 h-5">
                </span>
                <span className="text-sm font-medium">
                  {fromUnixToFullVisitdateStr(start_at, location.timeZone).split(",").slice(1).join(",")}</span>
              </div>
              <span className="text-sm font-medium uppercase">
                {getHourFromUnix(start_at, location.timeZone)}
              </span>
            </div>
          </div>
          {initiation === "bookingDetails" ?
            <div className="flex gap-4">
              <div className="flex flex-col justify-center items-center">
                <PetsIcon />
              </div>
              <div className="flex flex-col gap-1">
                <div className="capitalize">
                  <span className="text-sm font-semibold">{selectedVisit?.pet.name} </span>
                  <span className="text-sm font-medium">{user?.lastName}</span>
                </div>
                {selectedVisit && <span className="text-gray-1 text-sm">{`${selectedVisit.pet.breedName ||
                  selectedVisit.pet.speciesName === "Other" && "Others"}${", "}
                ${getGender(selectedVisit.pet.gender)}`}</span>}
              </div>
            </div> :
            appointment.pet?
              <div className="flex gap-4">
                <div className="flex flex-col justify-center items-center">
                  <PetsIcon />
                </div>
                <div className="flex flex-col gap-1">
                  <div className="capitalize">
                    <span className="text-sm font-semibold">{appointment.pet.name} </span>
                    <span className="text-sm font-medium">{user?.lastName}</span>
                  </div>
                  <span className="text-gray-1 text-sm">{`${appointment.pet.breedName ||
                     appointment.pet.speciesName === "Other" && "Others"}${", "}
                ${getGender(appointment.pet.gender)}`}</span>
                </div>
              </div> :
              appointment.pets.length===1 ?
                <div className="flex gap-4">
                  <div className="flex flex-col justify-center items-center">
                    <PetsIcon />
                  </div>
                  <div className="flex flex-col gap-1">
                    <div className="capitalize">
                      <span className="text-sm font-semibold">{appointment.pets[0].name} </span>
                      <span className="text-sm font-medium">{user?.lastName}</span>
                    </div>
                    <span className="text-gray-1 text-sm">{`${appointment.pets[0].breedName ||
                     appointment.pets[0].speciesName === "Other" && "Others"}${", "}
                    ${getGender(appointment.pets[0].gender)}`}</span>
                  </div>
                </div> :
                <div className="flex gap-4">
                  <div className="flex flex-col"><PetsIcon /></div>
                  <div>
                    {appointment.pets.map((data: any, index: number) =>
                      <>
                        <span key={data.id} className="capitalize font-semibold">
                          {data.name + " "}
                        </span>
                        <span key={data.id} className="capitalize">
                          {index === appointment.pets.length-1 ? user?.lastName : user?.lastName+", "}
                        </span>
                      </>,
                    )}
                  </div>
                </div>}
          <div className="flex gap-5">
            <div className="flex flex-col justify-center items-center"><BookingStethIcon /></div>
            <span className="text-sm font-semibold">{reasonsForVisit?.join(", ") || appointmentType}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingDetails;
